// extracted by mini-css-extract-plugin
module.exports = {"scrollableContainer":"ScrollableContainer_scrollableContainer__28tBB"};